export default __webpack_public_path__ + "static/media/About_BG_Light.2b7117c5.jpg";